import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import LoadingBox from "../../../component/LoadingBox";
import MessageBox from "../../../component/MessageBox";
import ReactHtmlParser from "react-html-parser";
import Modal from "../../../UI/Modal";
import { replace_string, server_django } from "../../../util";

const DeansMessage = ({ program, faculty, department, messageFrom }) => {
  const [readMore, setReadmore] = useState(false);
  const { data, loading, error } = useFetch("employee/message");

  if (loading) return <LoadingBox />;
  if (error) return <MessageBox>{error}</MessageBox>;
  const myList = program;

  let filterCondition = (obj) => {
    return obj.employee?.role?.some((item) => item.role === messageFrom);
  };

  if (faculty) {
    filterCondition = (obj) => {
      const roleCondition = obj.employee?.role?.some(
        (item) => item.role === messageFrom
      );
      const facultyCondition = obj.faculty?.collegecode === faculty; // Adjust based on your actual condition

      // Combine the conditions based on your requirements (e.g., both conditions should be true)
      return roleCondition && facultyCondition;
    };
  }

  if (department) {
    filterCondition = (obj) => {
      const roleCondition = obj.employee?.role?.some(
        (item) => item.role === messageFrom
      );
      const facultyCondition = obj.employee?.department?.some(
        (item) => item.depid === department
      ); // Adjust based on your actual condition

      // Combine the conditions based on your requirements (e.g., both conditions should be true)
      return roleCondition && facultyCondition;
    };
  }

  const messageObj = data?.find(filterCondition);

  const programList = myList.map((mylist) => {
    return (
      <ul>
        <li>
          <NavLink exact to={mylist.link}>
            {mylist.title}
          </NavLink>
        </li>
      </ul>
    );
  });

  return messageObj ? (
    <div className="facultyContent">
      <div className="DeptSidemenu sameLevel mt-5">
        <div id="sidemenu2" className="sidemenu">
          <p className="heading4 text-left">Quick Links</p>
          {programList}
        </div>
      </div>
      <div className="DeptRightSide sameLevel mt-5">
        <p className="heading4 text-left">Message from the {messageFrom}</p>
        <div className="deanMessage">
          <img
            src={messageObj.employee.staff_picture.replace(
              replace_string,
              server_django
            )}
            alt={messageObj.employee.staff_name}
            className="img-fluid"
          />

          <p className="allText">
            {" "}
            {readMore
              ? ReactHtmlParser(messageObj.message.replace(/\r\n/g, "<br />"))
              : `${messageObj.message.substring(0, 450)}...`}
            <Modal>
              <Modal.Open opens="message-dean">
                <button>Read More</button>
              </Modal.Open>
              <Modal.Window name="message-dean">
                {/* ReactHtmlParser(messageObj.message.replace(/\r\n/g, "<br />
              ")) */}
                <MessageCom message={messageObj.message} />
              </Modal.Window>
            </Modal>
          </p>
        </div>
      </div>
    </div>
  ) : null;
};

export default DeansMessage;

function MessageCom({ message }) {
  return (
    <p className="allText">
      {ReactHtmlParser(message.replace(/\r\n/g, "<br />"))}
    </p>
  );
}
